export default "__VITE_ASSET__DBfRnTNO__"